import React, { Fragment, useMemo } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import * as moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/es';
/**/
import {
  EXTRA_SERVICES_PRICE_TYPES,
  PARTICIPANTS_SELECTION_TYPES,
  PURCHASE_TYPE,
} from '../../../constants';
import endpoints from '../../define/endpoints';
import pages from '../../define/pages';
import { formatCurrency } from '../../utils/format';
import { VoucherDuration } from './VoucherDuration';
import ApplyCoupon from './../ApplyCoupon';
import Coupon from '../ApplyCoupon/coupon';
import { useAuth0 } from '../../context/auth0';
import BetaIcon, { IconSizes } from '../Icons/Icon';

import { Icon, InlineIcon } from '@iconify/react';
import iconMapMarker from '@iconify-icons/mdi/map-marker-outline';
import iconPeople from '@iconify-icons/mdi/people-outline';
import iconEdit from '@iconify-icons/mdi/edit-outline';

import { getCoreLanguageCode } from '../../hooks/useCoreLanguageCodes';
import { RecapCredit as WelfareCredit } from '../WelfareComponents/RecapCredit';
import Cookies from 'universal-cookie';
import { Modal } from '../modals';

moment.locale(freedomeConfig.locale);

const OrderRecap = (props) => {
  const productLink = useMemo(() => {
    return `${app_main_wpml.product_directory}/${props.listing && props.listing.slug
      }/`;
  }, [props.listing]);

  const mapNumberToStarIconNames = (n) => {
    const nonEmptyStarsArr = new Array(parseInt(n)).fill('valutationStar1');
    n % 1 && nonEmptyStarsArr.push('valutationStar05');
    return [
      ...nonEmptyStarsArr,
      ...new Array(5 - nonEmptyStarsArr.length).fill('valutationStar0'),
    ];
  };

  const getCancellationDeadline = () => {
    if (!props.listing || !props.listing.cancellation || !props.cart || !props.cart.availabilityDatetime) {
      return null;
    }

    const cancellationPolicies = {
      last_minute: { hours: 24 },
      very_flexible: { hours: 48 },
      flexible: { days: 5 },
      moderate: { days: 8 },
      strict: { days: 15 },
      very_strict: { days: 31 }
    };

    const policy = cancellationPolicies[props.listing.cancellation];
    if (!policy) return null;

    const activityDate = moment(props.cart.availabilityDatetime);
    let deadline;

    if (policy.hours) {
      deadline = activityDate.clone().subtract(policy.hours, 'hours');
    } else if (policy.days) {
      deadline = activityDate.clone().subtract(policy.days, 'days');
    }

    if (deadline && deadline.isBefore(moment())) {
      return null;
    }

    return deadline;
  };

  const extraServicesLink = useMemo(() => {
    return pages.extraServices;
  }, []);

  const checkoutLink = useMemo(() => {
    return pages.checkout;
  }, []);

  const { user } = useAuth0();

  const { applyCoupon, removeCoupon, cart } = props;

  const cookies = new Cookies();
  var provided_user = cookies.get('welfare_user') ?? null;

  var hide_total =
    provided_user && provided_user.credit >= (cart && cart.priceTotal);

  //TODO: change get route in core to get language by code
  var language_id =
    props.selectedLanguageId != 0
      ? props.selectedLanguageId
      : window.freedomeConfig.locale;
  const localeIsEn = window.freedomeConfig.locale === 'en';
  const selectedLang = getCoreLanguageCode(language_id);
  const coupons = cart?.coupons?.map((c) => (
    <Coupon removeCoupon={removeCoupon} coupon={c}></Coupon>
  ));
  const [showConfirmationDialog, setShowConfirmationDialog] =
    React.useState(false);

  return (
    <>
      <div className={cn('order-recap', props.className)}>
        <Modal
          onClickOverlay={() => setShowConfirmationDialog(false)}
          isOpen={showConfirmationDialog}
          shouldScroll={false}
        >
          <div className={cn('modal-generic')}>
            <p className={cn('modal-generic__title')}>
              {app_main_wpml.edit_booking_modal_header}
            </p>
            <p className={cn('modal-generic__content')}>
              {app_main_wpml.edit_booking_modal_content}
            </p>
            <div className={cn('modal-generic__buttons')}>
              <a
                className={cn('btn', 'btn--short', 'btn--secondary')}
                onClick={() => setShowConfirmationDialog(false)}
              >
                {app_main_wpml.cancel}
              </a>
              <a
                className={cn('btn', 'btn--short')}
                href={`${productLink}?edit=true`}
              >
                {app_main_wpml.confirm}
              </a>
            </div>
          </div>
        </Modal>

        {props.cart && props.cart.type === PURCHASE_TYPE.VOUCHER && (
          <VoucherDuration withMarginBottom />
        )}
        <div
          className={`${props.cart && props.cart.type === PURCHASE_TYPE.GIFTCARD
            ? 'giftcard '
            : ''
            } order-recap__head`}
        >
          {!!props.listing && !!props.listing.coverImage && (
            <img
              srcSet={`
              ${endpoints.bucket}${props.listing.coverImage}?crop=2:1.3,smart&width=200 1x, 
              ${endpoints.bucket}${props.listing.coverImage}?crop=2:1.3,smart&width=400 2x,
            `}
              className="order-recap__head__img rounded"
              alt={props.listing.title}
            />
          )}
          {props.cart && props.cart.type === PURCHASE_TYPE.GIFTCARD ? (
            <div className="texts">
              <h4 className="texts__title">{app_main_wpml.gift_card_title}</h4>
            </div>
          ) : (
            <div className="texts">
              <p className="texts__position">
                <Icon icon={iconMapMarker} className="icon" />
                <span className="text-position">
                  {props.listing &&
                    props.listing.city != props.listing.province &&
                    `${props.listing.city}, ${props.listing.province}`}
                  {props.listing &&
                    props.listing.city == props.listing.province &&
                    `${props.listing.city}`}
                </span>
              </p>
              <h6 className="texts__title">
                {props.listing && props.listing.title}
                {props.product &&
                  props.product.title != null &&
                  ' - ' + props.product.title}
              </h6>
              {props.listing && props.listing.reviewScoreAverage > 4 && (
                <div className="reviews__stars" style={{ marginTop: '8px', alignItems: 'center' }}>
                  {mapNumberToStarIconNames(props.listing.reviewScoreAverage).map((iconName, i) => {
                    return <div key={i} style={{ marginBottom: '2px' }}><BetaIcon name={iconName} size={IconSizes[16]} /></div>;
                  })}
                  <span className="typography__p4 typography__weight--bold typography__neutral" style={{ marginLeft: '8px', lineHeight: '1.5' }}>
                    {props.listing.reviewScoreAverage.toFixed(1)}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        {props.cart && props.cart.type === PURCHASE_TYPE.GIFTCARD ? (
          <>
            <div className="order-recap__meta">
              <div className="meta">
                {(function () {
                  if (!props.cart) {
                    return null;
                  }
                  return (
                    <div className="meta__value">
                      <p className="meta__value__text meta__value__text__bold">
                        {<BetaIcon name="giftcard" classNames="icon" />}
                        {`${props.cart.participants.quantity} x ${app_main_wpml.gift_card.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())} ${props.cart.singlePrice}€`}
                      </p>
                      <p className="meta__value__amount">
                        {props.cart.participants.priceTotal} €
                      </p>
                    </div>
                  );
                })()}
              </div>

              <div className="meta">
                <div className="meta__key">
                  {props.showModifyParticipants && (
                    <div className='d-flex gap-3xs'>
                      <Icon icon={iconEdit} className="icon" />
                      <a
                        href={app_main_wpml.giftcard_link}
                        className="meta__key__edit meta__value__text__bold"
                      >
                        {app_main_wpml.edit_order}
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {props.cart &&
                (props.cart.dedicationName || props.cart.dedicationMessage) && (
                  <div className="meta">
                    <div className="meta__key">
                      {cart &&
                        cart.type == PURCHASE_TYPE.GIFTCARD &&
                        cart.participants.quantity > 1 ? (
                        <h6 className="meta__key__title" style={{ marginBottom: '4px' }}>
                          {app_main_wpml.message}
                        </h6>
                      ) : (
                        <h6 className="meta__key__title" style={{ marginBottom: '4px' }}>
                          {app_main_wpml.dedicated_to}
                        </h6>
                      )}
                    </div>
                    <div className="meta__value meta__value--vertical">
                      {props.cart.dedicationName && (
                        <p className="meta__value__text">
                          {props.cart.dedicationName}
                        </p>
                      )}
                      {props.cart.dedicationMessage && (
                        <div className="meta__value__text">
                          {props.cart.dedicationMessage
                            .split('\n')
                            .map((text, i) => (
                              <div key={i} style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>{text}</div>
                            ))}
                        </div>
                      )}
                      {props.showModifyDedications && (
                        <div className='d-flex gap-3xs margin-top--1'>
                          <Icon icon={iconEdit} className="icon" />
                          <a
                            href={`${checkoutLink}?force_dedication=1`}
                            className="meta__key__edit meta__value__text__bold"
                          >
                            {app_main_wpml.edit_dedication}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {user?.role === 'admin' && (
                <ApplyCoupon {...({ applyCoupon, removeCoupon, cart, errorMessage: props.couponError, clearError: props.clearCouponError })} />
              )}
            </div>
            <div className="order-recap__trust">
              <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.66667 3.33333V0L2.5 4.16667L6.66667 8.33333V5C7.99275 5 9.26452 5.52678 10.2022 6.46447C11.1399 7.40215 11.6667 8.67392 11.6667 10C11.6667 11.3261 11.1399 12.5979 10.2022 13.5355C9.26452 14.4732 7.99275 15 6.66667 15C5.34058 15 4.06881 14.4732 3.13113 13.5355C2.19345 12.5979 1.66667 11.3261 1.66667 10H0C0 11.7681 0.702379 13.4638 1.95262 14.714C3.20286 15.9643 4.89856 16.6667 6.66667 16.6667C8.43478 16.6667 10.1305 15.9643 11.3807 14.714C12.631 13.4638 13.3333 11.7681 13.3333 10C13.3333 8.23189 12.631 6.5362 11.3807 5.28595C10.1305 4.03571 8.43478 3.33333 6.66667 3.33333Z" fill="#00883F" />
              </svg>
              <div className="order-recap__trust__text">
                <p className="order-recap__trust__title">{app_main_wpml.eighteen_months_validity}</p>
                <p className="order-recap__trust__subtitle">{app_main_wpml.from_purchase_date}</p>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="order-recap__meta">
              {props.cart && props.cart.availabilityDatetime && (
                <div className="meta">
                  <div className="meta__value">
                    <p className="meta__value__text meta__value__text__bold">
                      <BetaIcon name="calendar" classNames="icon" />
                      {moment(props.cart.availabilityDatetime).format(
                        'D MMMM YYYY, HH:mm'
                      )}
                    </p>
                  </div>
                </div>
              )}

              <div className="meta meta__gap">
                {(function () {
                  if (!props.cart) {
                    return null;
                  }
                  switch (props.cart.priceType) {
                    case PARTICIPANTS_SELECTION_TYPES.TOP:
                      return (
                        <Fragment>
                          {!!Object.keys(props.cart.participants.top1).length &&
                            !!props.cart.participants.top1.quantity && (
                              <div className="meta__value">
                                <p className="meta__value__text meta__value__text__bold">
                                  <Icon icon={iconPeople} className="icon" />
                                  {`${props.cart.participants.top1.quantity} x ${props.cart.participants.top1.label}`}
                                </p>
                                <p className="meta__value__amount">
                                  {props.cart.participants.top1.priceTotal} €
                                </p>
                              </div>
                            )}
                          {!!Object.keys(props.cart.participants.top2).length &&
                            !!props.cart.participants.top2.quantity && (
                              <div className="meta__value">
                                <p className="meta__value__text meta__value__text__bold">
                                  <Icon icon={iconPeople} className="icon" />
                                  {`${props.cart.participants.top2.quantity} x ${props.cart.participants.top2.label}`}
                                </p>
                                <p className="meta__value__amount">
                                  {props.cart.participants.top2.priceTotal} €
                                </p>
                              </div>
                            )}
                        </Fragment>
                      );
                    case PARTICIPANTS_SELECTION_TYPES.TOP3:
                      return (
                        <Fragment>
                          {!!Object.keys(props.cart.participants.top1).length &&
                            !!props.cart.participants.top1.quantity && (
                              <div className="meta__value">
                                <p className="meta__value__text meta__value__text__bold">
                                  <Icon icon={iconPeople} className="icon" />
                                  {`${props.cart.participants.top1.quantity} x ${props.cart.participants.top1.label}`}
                                </p>
                                <p className="meta__value__amount">
                                  {props.cart.participants.top1.priceTotal} €
                                </p>
                              </div>
                            )}
                          {!!Object.keys(props.cart.participants.top2).length &&
                            !!props.cart.participants.top2.quantity && (
                              <div className="meta__value">
                                <p className="meta__value__text meta__value__text__bold">
                                  <Icon icon={iconPeople} className="icon" />
                                  {`${props.cart.participants.top2.quantity} x ${props.cart.participants.top2.label}`}
                                </p>
                                <p className="meta__value__amount">
                                  {props.cart.participants.top2.priceTotal} €
                                </p>
                              </div>
                            )}
                          {!!Object.keys(props.cart.participants.top3).length &&
                            !!props.cart.participants.top3.quantity && (
                              <div className="meta__value">
                                <p className="meta__value__text meta__value__text__bold">
                                  <Icon icon={iconPeople} className="icon" />
                                  {`${props.cart.participants.top3.quantity} x ${props.cart.participants.top3.label}`}
                                </p>
                                <p className="meta__value__amount">
                                  {props.cart.participants.top3.priceTotal} €
                                </p>
                              </div>
                            )}
                        </Fragment>
                      );
                    case PARTICIPANTS_SELECTION_TYPES.GROUP:
                    case PARTICIPANTS_SELECTION_TYPES.FIXED:
                    case PARTICIPANTS_SELECTION_TYPES.VARIABLE:
                      return (
                        <div className="meta__value">
                          <p className="meta__value__text meta__value__text__bold">
                            <Icon icon={iconPeople} className="icon" />
                            {`${props.cart.participants.quantity} x ${props.cart.participants.label}`}
                          </p>
                          <p className="meta__value__amount">
                            {props.cart.participants.priceTotal} €
                          </p>
                        </div>
                      );
                    default:
                      return null;
                  }
                })()}
              </div>

              {props.areSomeOptionalsSelected && (
                <div className="meta">
                  <div className="meta__key">
                    <h6 className="meta__key__title">Servizi</h6>
                    {props.showModifyExtraServices && (
                      <a href={extraServicesLink} className="meta__key__edit">
                        {app_main_wpml.edit}
                      </a>
                    )}
                  </div>
                  {props.optionals.map((optional, i) => {
                    const selectedExtraService =
                      props.selectedOptionals[optional.id];
                    if (!selectedExtraService || !selectedExtraService.status) {
                      return null;
                    }
                    const isGroup =
                      optional.priceType === EXTRA_SERVICES_PRICE_TYPES.GROUP;
                    const title = isGroup
                      ? optional.title
                      : `${selectedExtraService.status} x ${optional.title}`;
                    const price = isGroup
                      ? optional.price
                      : optional.price * selectedExtraService.status;
                    return (
                      <div key={i} className="meta__value">
                        <p className="meta__value__text meta__value__text__bold">{title}</p>
                        <p className="meta__value__amount">
                          {formatCurrency(price)}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}

              {selectedLang && localeIsEn && (
                <div className="meta">
                  <div className="meta__value">
                    <div className="meta__key">
                      <span
                        className="meta__flag_margin overlay-flag iconify"
                        data-icon={'circle-flags:lang-' + selectedLang.code}
                      ></span>
                      <p className="meta__value__text">
                        <>
                          <strong>{app_main_wpml.language}</strong>
                          <br />
                        </>
                        {selectedLang.title}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="meta">
                <div className="meta__key">
                  {props.showModifyParticipants && (
                    <div className='d-flex gap-3xs'>
                      <Icon icon={iconEdit} className="icon" />
                      <a
                        // href={productLink}
                        className="meta__key__edit meta__value__text__bold"
                        onClick={() => setShowConfirmationDialog(true)}
                      >
                        {app_main_wpml.edit_order}
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {props.cart &&
                (props.cart.dedicationName || props.cart.dedicationMessage) && (
                  <div className="meta">
                    <div className="meta__key">
                      <h6 className="meta__key__title" style={{ marginBottom: '4px' }}>
                        {app_main_wpml.dedicated_to}
                      </h6>
                    </div>
                    <div className="meta__value meta__value--vertical">
                      {props.cart.dedicationName && (
                        <p className="meta__value__text">
                          {props.cart.dedicationName}
                        </p>
                      )}
                      {props.cart.dedicationMessage && (
                        <div className="meta__value__text">
                          {props.cart.dedicationMessage
                            .split('\n')
                            .map((text, i) => (
                              <div key={i} style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>{text}</div>
                            ))}
                        </div>
                      )}
                    </div>
                    {props.showModifyDedications && (
                      <div className='d-flex gap-3xs margin-top--1'>
                        <Icon icon={iconEdit} className="icon" />
                        <a
                          href={`${checkoutLink}?force_dedication=1`}
                          className="meta__key__edit meta__value__text__bold"
                        >
                          {app_main_wpml.edit_dedication}
                        </a>
                      </div>
                    )}
                  </div>
                )}
            </div>
            {props.cart && props.cart.type === PURCHASE_TYPE.VOUCHER && (
              <div className="order-recap__trust">
                <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66667 3.33333V0L2.5 4.16667L6.66667 8.33333V5C7.99275 5 9.26452 5.52678 10.2022 6.46447C11.1399 7.40215 11.6667 8.67392 11.6667 10C11.6667 11.3261 11.1399 12.5979 10.2022 13.5355C9.26452 14.4732 7.99275 15 6.66667 15C5.34058 15 4.06881 14.4732 3.13113 13.5355C2.19345 12.5979 1.66667 11.3261 1.66667 10H0C0 11.7681 0.702379 13.4638 1.95262 14.714C3.20286 15.9643 4.89856 16.6667 6.66667 16.6667C8.43478 16.6667 10.1305 15.9643 11.3807 14.714C12.631 13.4638 13.3333 11.7681 13.3333 10C13.3333 8.23189 12.631 6.5362 11.3807 5.28595C10.1305 4.03571 8.43478 3.33333 6.66667 3.33333Z" fill="#00883F" />
                </svg>
                <div className="order-recap__trust__text">
                  <p className="order-recap__trust__title">{app_main_wpml.twelve_months_validity}</p>
                  <p className="order-recap__trust__subtitle">{app_main_wpml.from_purchase_date}</p>
                </div>
              </div>
            )}

            {props.cart && props.cart.type === PURCHASE_TYPE.BOOKING && getCancellationDeadline() && (
              <div className="order-recap__trust">
                <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66667 3.33333V0L2.5 4.16667L6.66667 8.33333V5C7.99275 5 9.26452 5.52678 10.2022 6.46447C11.1399 7.40215 11.6667 8.67392 11.6667 10C11.6667 11.3261 11.1399 12.5979 10.2022 13.5355C9.26452 14.4732 7.99275 15 6.66667 15C5.34058 15 4.06881 14.4732 3.13113 13.5355C2.19345 12.5979 1.66667 11.3261 1.66667 10H0C0 11.7681 0.702379 13.4638 1.95262 14.714C3.20286 15.9643 4.89856 16.6667 6.66667 16.6667C8.43478 16.6667 10.1305 15.9643 11.3807 14.714C12.631 13.4638 13.3333 11.7681 13.3333 10C13.3333 8.23189 12.631 6.5362 11.3807 5.28595C10.1305 4.03571 8.43478 3.33333 6.66667 3.33333Z" fill="#00883F" />
                </svg>
                <div className="order-recap__trust__text">
                  <p className="order-recap__trust__title">{app_main_wpml.free_cancellation}</p>
                  <p className="order-recap__trust__subtitle">
                    {app_main_wpml.cancellation_deadline
                      .replace('%HOUR%', getCancellationDeadline().format('HH:mm'))
                      .replace('%DATE%', getCancellationDeadline().format('DD MMMM YYYY'))
                    }
                  </p>
                </div>
              </div>
            )}
            {props.hideCouponInput == false && !provided_user && (
              <ApplyCoupon {...({ applyCoupon, removeCoupon, cart, errorMessage: props.couponError, clearError: props.clearCouponError })} />
            )}

            {coupons && coupons.length > 0 && (
              <div style={{ marginTop: '12px' }}>
                {coupons}
              </div>
            )}
          </>
        )}

        {provided_user && (
          <WelfareCredit
            cartTotal={cart && cart.priceTotal}
            credit={provided_user.credit}
            providerLabel={provided_user.provider}
          />
        )}

        <div className="order-recap__price">
          <p className="order-recap__price__amount">{app_main_wpml.total}</p>
          {hide_total ? (
            <p className="order-recap__price__amount">
              {cart && cart.priceTotal} {app_main_wpml.points}
            </p>
          ) : (
            <div className='order-recap__price__wrapper'>
              <p className="order-recap__price__amount">
                {cart && cart.priceSubtotal && cart.priceSubtotal !== cart.priceTotal && (
                  <span style={{ textDecoration: 'line-through', fontSize: '12px', fontWeight: 'normal', marginRight: '4px' }}>{formatCurrency(cart.priceSubtotal)}</span>
                )}
                {formatCurrency(cart && cart.priceTotal)}
              </p>
              <small>
                {app_main_wpml.taxes_and_fees_included}
              </small>
            </div>
          )}
        </div>
      </div>
      {props.showSubmitForm && (
        <div className={cn('order-recap__button-container order-recap--hidden-under-tablet-landscape')}>
          <button
            type="submit"
            className={cn('btn', 'btn--expanded', {
              'btn--primary': props.isButtonHighlighted,
            })}
          >
            {props.isButtonHighlighted
              ? app_main_wpml.continue
              : app_main_wpml.skip}
          </button>
        </div>
      )}
    </>
  );
};

OrderRecap.propTypes = {
  totalPrice: PropTypes.number.isRequired,
  className: PropTypes.string,
  selectedOptionals: PropTypes.shape().isRequired,
  optionals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      priceType: PropTypes.oneOf([
        EXTRA_SERVICES_PRICE_TYPES.PERSON,
        EXTRA_SERVICES_PRICE_TYPES.GROUP,
      ]).isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  showSubmitForm: PropTypes.bool.isRequired,
  areSomeOptionalsSelected: PropTypes.bool,
  listing: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    province: PropTypes.string.isRequired,
    coverImage: PropTypes.string.isRequired,
  }),
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }),
  cart: PropTypes.shape({
    availabilityDatetime: PropTypes.string,
    selectedLanguageId: PropTypes.number,
    priceType: PropTypes.oneOf([
      PARTICIPANTS_SELECTION_TYPES.TOP,
      PARTICIPANTS_SELECTION_TYPES.TOP3,
      PARTICIPANTS_SELECTION_TYPES.VARIABLE,
      PARTICIPANTS_SELECTION_TYPES.FIXED,
      PARTICIPANTS_SELECTION_TYPES.GROUP,
    ]),
    participants: PropTypes.oneOfType([
      PropTypes.shape({
        top1: PropTypes.shape({
          description: PropTypes.string,
          label: PropTypes.string,
          quantity: PropTypes.number.isRequired,
          priceTotal: PropTypes.string,
        }),
        top2: PropTypes.shape({
          description: PropTypes.string,
          label: PropTypes.string,
          quantity: PropTypes.number.isRequired,
          priceTotal: PropTypes.string,
        }),
        top3: PropTypes.shape({
          description: PropTypes.string,
          label: PropTypes.string,
          quantity: PropTypes.number.isRequired,
          priceTotal: PropTypes.string,
        }),
      }),
      PropTypes.shape({
        description: PropTypes.string,
        label: PropTypes.string.isRequired,
        quantity: PropTypes.number.isRequired,
        priceTotal: PropTypes.string.isRequired,
      }),
    ]).isRequired,
    type: PropTypes.oneOf([
      PURCHASE_TYPE.BOOKING,
      PURCHASE_TYPE.VOUCHER,
      PURCHASE_TYPE.GIFTCARD,
    ]),
    dedicationName: PropTypes.string,
    dedicationMessage: PropTypes.string,
  }),
  showModifyDatetime: PropTypes.bool.isRequired,
  showModifyParticipants: PropTypes.bool.isRequired,
  showModifyExtraServices: PropTypes.bool.isRequired,
  showModifyDedications: PropTypes.bool.isRequired,
  isButtonHighlighted: PropTypes.bool.isRequired,
  hideCouponInput: PropTypes.bool,
};

OrderRecap.defaultProps = {
  showSubmitForm: true,
  showModifyDatetime: true,
  showModifyParticipants: true,
  showModifyExtraServices: true,
  showModifyDedications: true,
  isButtonHighlighted: false,
  hideCouponInput: false,
};

export { OrderRecap };
